import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import { useIsQuotationMode } from './useIsQuotationMode';

// Order and quotation carts are stored under separate ids so they can't mix.
// Shared cart consumers (add/edit-to-cart, cart cards, overview) resolve the
// active id through this hook: quotation flow → quotationCartId, everything
// else (orders/configure/dealer/external) → shoppingCartId. This keeps the
// order flow's behavior unchanged.
// Returns '' (not null) when no cart is set: both are falsy, so the existing
// `shoppingCartId && ...` guards behave identically, and consumers that require
// a string param don't each need to coerce.
export const useActiveCartId = (): string => {
  const isQuotationMode = useIsQuotationMode();
  const { shoppingCartId, quotationCartId } = useSelector(
    (state: IRootReducerState) => state.shoppingCartInfo
  );
  return (isQuotationMode ? quotationCartId : shoppingCartId) ?? '';
};
